import { useCallback } from 'react';
import type { ActionHandlerType, OnActionArgs } from '../../../../context/ActionsProvider/context';
import type { GlobalStateStoreFlows } from '../../../../stores/GlobalStateStore';
import { useGetGlobalStateStoreStateByInstanceId } from '../../../../stores/GlobalStateStore';
import { useGetNoCodeComputedData } from '../../../computeContext/useGetNoCodeComputedData';
import { SHOULD_NOT_PROPAGATE_UP } from '../../const';

function useShareEntityRecord() {
  const { getNoCodeComputedData } = useGetNoCodeComputedData();
  const getGlobalStateStoreState = useGetGlobalStateStoreStateByInstanceId();

  const shareEntityRecord: ActionHandlerType = useCallback(
    ({ action, actionContext, instanceId }: OnActionArgs) => {
      const { actions } = getGlobalStateStoreState(instanceId);
      const payload = action.payload as GlobalStateStoreFlows['shareEntityRecord'];
      const computedPayload = getNoCodeComputedData<GlobalStateStoreFlows['shareEntityRecord']>(
        payload ?? {},
        actionContext,
      );

      if (payload?.entityId && payload.entityType) {
        return new Promise<boolean>((resolve, reject) => {
          actions.setPreBuiltFlow({
            type: 'shareEntityRecord',
            data: {
              ...computedPayload,
              onSuccess: () => resolve(SHOULD_NOT_PROPAGATE_UP),
              onClose: () => resolve(SHOULD_NOT_PROPAGATE_UP),
              onError: () => reject(SHOULD_NOT_PROPAGATE_UP),
            },
          });
        });
      }
      return Promise.resolve(SHOULD_NOT_PROPAGATE_UP);
    },
    [getNoCodeComputedData, getGlobalStateStoreState],
  );

  return { shareEntityRecord };
}

export default useShareEntityRecord;
